import * as THREE from 'three';
import { NearPointDelete } from './nearPointDelete';
import { ClosePath } from '../objects/ClosePath';


export class linearity {

    private epsilon: number = 0.0001;

    public check(shape: ClosePath, e: number): number[] {
        
        const numberOfPoints = shape.position.length;

        const result: boolean[] = new Array(numberOfPoints);
        result.fill(false);

        const nearPoint = new NearPointDelete();
        nearPoint.setDistance(this.epsilon);
        nearPoint.check(shape).forEach((index: number)=> {
            result[index] = true;
        });

        let isDel = true;
        while(isDel) {
            //近傍点を除いたインデックスの作成.
            let indexes = [...Array(numberOfPoints).keys()].filter((v: number, index: number) => !result[index]);

            // 面を構成する点が二点以下なら
            if(indexes.length <= 2) {
                return [...Array(numberOfPoints).keys()];
            }
            isDel = this.a(shape, indexes, result, e);
        }
        const num = result.filter((n:boolean) => n === true).length;
        if((numberOfPoints - num) <= 2) {
            return [...Array(numberOfPoints).keys()];
        }
        return [...Array(numberOfPoints).keys()].filter((v: number, index: number) => result[index]);
    }

    private a(shape: ClosePath, indexes: number[], result: boolean[], e: number): boolean {
        for (let i = 0; i < indexes.length; i++) {

            const index1 = indexes[i];
            const index2 = indexes[(i + 1) % indexes.length];
            const index3 = indexes[(i + 2) % indexes.length];
            const p1 = shape.position[index1];
            const p2 = shape.position[index2];
            const p3 = shape.position[index3];

            const isDelete = this.isDel(p1, p2, p3, e);
            if (isDelete) {
                result[index2] = isDelete;
                return true;
            }
        }
        return false;
    }

    private isDel(p1: THREE.Vector2 ,p2: THREE.Vector2 ,p3: THREE.Vector2, e: number): boolean {

        const a = p2.clone().sub(p1);
        const b = p3.clone().sub(p1);
        const l2 = b.length();

        const outer_pro: number = a.cross(b);
        const d: number = Math.abs(outer_pro / l2);

        // 高さが誤差の数値より大きかったら削除対象ではない
        if (e < d) return false;

        const inner_pro: number = a.dot(b);
        const x = inner_pro / l2;

        // 垂直に下したときの線が線分上になかったら削除対象ではない
        if (x > l2 || x < 0) return false;

        return true;
    }

}
